import { normalizeWord } from "./normalization";
import { phaseForOrdinal } from "./rules";

export interface SpawnGateInput {
  ordinal: number;
  word: string;
  nowMs: number;
  phaseReadyAtMs: number;
  nextSpawnAtMs: number;
  activeWords: string[];
}

export type SpawnGateReason =
  "ready" | "phase_wait" | "interval_wait" | "capacity" | "initial_conflict";

export function spawnGate(input: SpawnGateInput): SpawnGateReason {
  if (input.nowMs < input.phaseReadyAtMs) return "phase_wait";
  if (input.nowMs < input.nextSpawnAtMs) return "interval_wait";
  const phase = phaseForOrdinal(input.ordinal);
  if (input.activeWords.length >= phase.maxActive) return "capacity";
  const initial = normalizeWord(input.word)[0];
  if (input.activeWords.some((word) => normalizeWord(word)[0] === initial))
    return "initial_conflict";
  return "ready";
}

export function phaseCanAdvance(
  phaseIndex: number,
  processedCount: number,
  activeCount: number,
): boolean {
  const phaseEnds = [6, 14, 20] as const;
  const end = phaseEnds[phaseIndex];
  return (
    end !== undefined &&
    processedCount >= end &&
    activeCount === 0 &&
    phaseIndex < 2
  );
}

export function normalizedFallProgress(
  nowMs: number,
  startedAtMs: number,
  durationMs: number,
): number {
  return Math.max(0, Math.min(1, (nowMs - startedAtMs) / durationMs));
}
